<template>
  <div class="qmyx-container my-customer">
    <div class="header">
      <div class="search-input">
        <input
          placeholder="请输入手机号码/客户姓名"
          @input="handleSearch"
          v-model="queryParam.cusTel"
        />
        <img
          class="search-icon"
          src="https://assets.rurushishi.com/yq-rs-make/huafa/img/search.png"
          @click="handleSearch"
        />
      </div>
      <div class="select-list">
        <div
          class="select-item"
          v-for="(sItem, sI) in selectList"
          :key="sI"
          @click="handleSelect(sI)"
        >
          <div :style="selectIndex === sI ? 'color:#F07B24' : ''">
            {{ sItem.name }}
          </div>
          <img
            src="https://assets.rurushishi.com/yq-rs-make/huafa/img/down.png"
          />
        </div>
      </div>
      <div class="customer-count" v-if="customerCount > 0">
        共{{ customerCount }}位客户
      </div>
    </div>
    <div class="customer-list">
      <div
        class="customer-item"
        v-for="(item, index) in customerData"
        @click="handleToDetail(item)"
        :key="index"
      >
        <div class="top">
          <div class="name">{{ item.cusName }}</div>
          <div class="phone">{{ item.cusTel }}</div>
          <div class="timeout">{{ getTimeStatus(item) }}</div>
        </div>
        <div class="bottom">
          <div class="left">
            <div class="time">推荐时间：{{ item.reportDate }}</div>
            <div class="address">{{ item.housesD }}</div>
          </div>
          <div class="right">
            <div
              class="btn"
              v-if="item.protectDay && item.protectDay === -1"
              @click.stop="handleRecommend(item)"
            >
              <img
                class="icon"
                src="https://assets.rurushishi.com/yq-rs-make/huafa/img/icon_customer_time.png"
              /><span>续报</span>
            </div>
            <div
              class="btn"
              style="margin-left:11px"
              @click.stop="handleCallPhone(item)"
            >
              <img
                class="icon"
                src="https://assets.rurushishi.com/yq-rs-make/huafa/img/icon_customer_phone.png"
              /><span>联系</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <select-pop
      v-if="showSelectPop"
      :drop-data="selectData"
      :value="selectItemValue"
      :show="showSelectPop"
      @close="handlePopClose"
      @change="handleQueryParamSelect"
      :pop-style="selectPopStyle"
    ></select-pop>
  </div>
</template>
<script>
import { getHouses, getCustomer } from "./api";
import { createNamespacedHelpers } from "vuex";
import { InfiniteScroll } from "mint-ui";
import SelectPop from "../components/select-pop";
const { mapMutations } = createNamespacedHelpers("qmyx");
import Vue from "vue";
Vue.use(InfiniteScroll);
const processArray = [
  { name: "全部", key: "02" },
  { name: "推荐中", key: "10" },
  { name: "到访", key: "20" },
  { name: "认筹", key: "30" },
  { name: "认购", key: "40" },
  { name: "签约", key: "50" },
  { name: "提佣资格", key: "60" },
  { name: "佣金发放", key: "70" },
  { name: "已过期", key: "01" }
];
const timeArray = [
  { name: "推荐时间由远到近", key: "10" },
  { name: "推荐时间由近到远", key: "11" },
  { name: "客户保护期天数由少到多", key: "20" },
  { name: "客户保护期天数由多到少", key: "21" }
];
export default {
  name: "My-Customer",
  components: {
    SelectPop
  },
  data() {
    return {
      customerCount: 0,
      searchKey: "",
      showSelectPop: false,
      selectIndex: -1,
      selectList: [
        { name: "项目", key: "" },
        { name: "进度", key: "02" },
        { name: "时间排序", key: "11" }
      ],
      houseDArray: [{ name: "全部", key: "" }], //项目
      queryParam: {
        cityId: "",
        cusTel: "",
        houseD: "",
        appStatus: "02",
        sortBy: "11",
        page: 1,
        size: 20
      },
      hasMore: true,
      refreshData: true,
      customerData: [],
      inputSearchTimer: null
    };
  },
  computed: {
    selectPopStyle() {
      if (this.selectIndex === 0) {
        return " justify-content: flex-start";
      } else if (this.selectIndex === 1) {
        return " justify-content: center";
      } else if (this.selectIndex === 2) {
        return " justify-content: flex-end";
      }
      return "justify-content: flex-start";
    },
    selectData() {
      if (this.selectIndex === 0) {
        return this.houseDArray;
      } else if (this.selectIndex === 1) {
        return processArray;
      } else if (this.selectIndex === 2) {
        return timeArray;
      }
      return [];
    },
    selectItemValue() {
      if (this.selectIndex > -1 && this.selectIndex < 3) {
        return this.selectList[this.selectIndex].key;
      }
      return "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name !== "my-customer-detail") {
        vm.loadHouses();
        vm.queryParam.cusTel = "";
        vm.handleSearch();
        vm.loadCustomer();
        vm.loadCustomer();
      }
    });
  },
  methods: {
    ...mapMutations(["saveBackupInfo", "saveSelectBuildings"]),
    handleSelect(index) {
      this.selectIndex = index;
      this.showSelectPop = true;
    },
    handlePopClose() {
      if (this.showSelectPop) {
        this.selectIndex = -1;
        this.showSelectPop = false;
        return true;
      }
      return false;
    },
    handleQueryParamSelect(key) {
      if (this.selectIndex > -1 && this.selectIndex < 3) {
        this.selectList[this.selectIndex].key = key;

        if (this.selectIndex === 0) {
          this.queryParam.houseD = key;
        } else if (this.selectIndex === 1) {
          this.queryParam.appStatus = key;
        } else if (this.selectIndex === 2) {
          this.queryParam.sortBy = key;
        }
        this.selectIndex = -1;
        this.loadCustomer();
      }
    },
    handleCallPhone(item) {
      if (this.handlePopClose()) return;

      location.href = `tel:${item.cusTel}`;
    },

    /**
     * 搜索
     */
    handleSearch() {
      if (this.inputSearchTimer) {
        clearTimeout(this.inputSearchTimer);
      }

      this.inputSearchTimer = setTimeout(() => {
        this.selectIndex = -1;
        this.showSelectPop = false;
        this.selectList = [
          { name: "项目", key: "" },
          { name: "进度", key: "02" },
          { name: "时间排序", key: "11" }
        ];
        this.queryParam = {
          ...this.queryParam,
          houseD: "",
          appStatus: "",
          sortBy: "11",
          page: 1
        };
        this.loadCustomer();
      }, 100);
    },
    async loadMore() {
      if (!this.hasMore) return;
      this.queryParam.page++;
      this.loadCustomer();
    },
    /**
     * 加载项目数据
     */
    async loadHouses() {
      const res = await getHouses();
      if (res && !res.saleMain && res.house) {
        res.house.forEach(houseItem => {
          const tempObj = this.houseDArray.find(
            hItem => houseItem.housesD === hItem.name
          );
          if (!tempObj) {
            this.houseDArray.push({
              name: houseItem.housesD,
              key: houseItem.housesD
            });
          }
        });
      }
    },
    /**
     * 加载客户数据
     */
    async loadCustomer() {
      const res = await getCustomer(this.queryParam);
      if (this.queryParam.page === 1) {
        this.customerData = [];
      }
      if (res && res.list && res.list.length > 0) {
        this.hasMore = true;
        this.customerCount = res.total;
        this.customerData.push(...res.list);
      } else {
        this.hasMore = false;
        this.customerCount = 0;
      }
    },
    /**
     * 数据排序
     */
    sortData() {
      const { sortBy } = this.queryParam;
      if (sortBy === "10") {
        //推荐时间由远到近
        this.customerData.sort((a, b) => {
          return (
            new Date(a.reportDate).getTime() - new Date(b.reportDate).getTime()
          );
        });
      } else if (sortBy === "11") {
        //推荐时间由近到远
        this.customerData.sort((a, b) => {
          return (
            new Date(b.reportDate).getTime() - new Date(a.reportDate).getTime()
          );
        });
      } else if (sortBy === "20") {
        //客户保护期天数由少到多
        this.customerData.sort((a, b) => {
          if (a.protectDay && b.protectDay) {
            return a.protectDay - b.protectDay;
          } else {
            return 0;
          }
        });
      } else if (sortBy === "21") {
        //客户保护期天数由多到少
        this.customerData.sort((a, b) => {
          if (a.protectDay && b.protectDay) {
            return b.protectDay - a.protectDay;
          } else {
            return 0;
          }
        });
      }
    },
    /**
     * 获取过期状态
     */
    getTimeStatus(item) {
      if (item.protectDay) {
        if (item.protectDay === -1) {
          return "已过期";
        } else {
          return `客户保护期剩余${item.protectDay}天`;
        }
      } else {
        return "";
      }
    },
    handleToDetail(item) {
      if (this.handlePopClose()) return;
      this.$router.push({
        name: "invite-client-recommend-customers-detail",
        params: {
          id: item.cusUuid
        }
      });
    },
    /**
     * 续报
     */
    handleRecommend(item) {
      if (this.handlePopClose()) return;

      this.saveBackupInfo({
        cusName: item.cusName,
        cusTel: item.cusTel
      });
      this.saveSelectBuildings([
        {
          housesUuid: item.housesId,
          housesD: item.housesD
        }
      ]);
      this.$router.push({ name: "client-backup" });
    }
  }
};
</script>
<style scoped lang="scss">
.my-customer {
  .customer-list {
    margin-top: 2.6rem;
  }
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: white;
    .search-input {
      background: #f2f2f2;
      border-radius: 0.32rem;
      border-radius: 0.32rem;
      height: 0.64rem;

      position: relative;
      margin: 0.32rem 0.48rem;
      input {
        background: transparent;
        vertical-align: middle;
        width: 80%;
        padding: 0.16rem 0.32rem;
        font-size: 0.26rem;
        ::placeholder {
          color: #999999;
        }
      }
      .search-icon {
        position: absolute;
        width: 0.36rem;
        height: 0.36rem;
        right: 0.32rem;
        top: 0.14rem;
      }
    }

    .select-list {
      display: flex;
      justify-content: center;
      align-items: center;
      .select-item {
        flex: 1;
        font-size: 0.3rem;
        color: #999999;
        display: flex;
        justify-content: center;
        img {
          width: 0.36rem;
          height: 0.36rem;
          margin-left: 0.08rem;
        }
      }
    }
    .customer-count {
      font-size: 0.3rem;
      color: #999999;
      letter-spacing: 0;
      margin-left: 0.48rem;
      margin-top: 0.4rem;
      padding-bottom: 0.2rem;
    }
  }
  .customer-item {
    min-height: 1.74rem;
    margin: 0.3rem 0.48rem;
    box-shadow: 0 0.02rem 0 0 #efefef;
    border-radius: 0.02rem;
    .top {
      display: flex;
      justify-self: start;
      align-items: center;
      .name {
        font-size: 0.34rem;
        color: #4a4a4a;
      }
      .phone {
        font-size: 0.28rem;
        color: #4a4a4a;
        letter-spacing: 0;
        flex: 1;
        margin-left: 0.28rem;
      }
      .timeout {
        font-size: 0.28rem;
        color: #f07b24;
        letter-spacing: 0;
        text-align: right;
      }
    }
    .bottom {
      display: flex;
      margin-top: 0.18rem;
      .left {
        flex: 1;
        .time {
          font-size: 0.24rem;
          color: #999999;
          letter-spacing: 0;
        }
        .address {
          font-size: 0.26rem;
          margin-top: 0.1rem;
          color: #999999;
          letter-spacing: 0;
        }
      }
      .right {
        display: flex;

        .btn {
          border: 0.02rem solid #f1a826;
          border-radius: 0.08rem;
          border-radius: 0.08rem;
          width: 1.16rem;
          height: 0.48rem;
          .icon {
            width: 0.26rem;
            height: 0.26rem;
          }
          span {
            font-size: 0.28rem;
            color: #f1a826;
            letter-spacing: 0;
            text-align: right;
            margin-left: 0.1rem;
          }
        }
      }
    }
  }
}
</style>
